<template>
  <div class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <!-- DIALOG TAMBAH SUMBER DANA -->
        <v-dialog v-model="dialog.sumberDanaForm"
          @keydown.esc="dialog.sumberDanaForm = false"
          width="500"
          persistent
          scrollable>
          <v-card class="border-radius">
            <div
              class="d-flex align-center pt-3 pb-0 px-4 body-1"
              style="font-weight: 600;">
              {{ sumberDanaForm.id ? 'Edit Sumber Dana' : 'Tambah Sumber Dana' }}

              <v-spacer/>

              <v-icon
                @click="dialog.sumberDanaForm = false; resetSumberDana();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>

            <v-divider
              class="mt-3 mb-1"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text class="pt-3 pb-2 px-4">
              <ValidationObserver ref="sumberDanaForm">
                <v-form>
                  <ValidationProvider
                    name="Posisi"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Posisi
                    </div>

                    <v-select
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Pilih Posisi"
                      hide-details="auto"
                      :items="positions"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"
                      v-model="sumberDanaForm.position"
                      :success="valid"
                      :error-messages="errors"
                      required
                      class="mb-5"
                      style="border-radius: 10px;"
                      @change="onSumberDanaFormPositionChange">
                    </v-select>
                  </ValidationProvider>

                  <ValidationProvider
                    name="COA"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Akun COA
                    </div>

                    <v-autocomplete
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Cari nama / nomor akun COA"
                      hide-details="auto"
                      :items="sumberDanaCoaList"
                      :loading="process.sumberDanaCoa"
                      :search-input.sync="search_coa"
                      item-text="name_number"
                      item-value="id"
                      :item-color="set_color"
                      v-model="sumberDanaForm.coa_id"
                      :success="valid"
                      :error-messages="errors"
                      required
                      class="mb-3"
                      style="border-radius: 10px;">
                      <template v-slot:item="{ item }">
                        <div class="d-flex align-center">
                          <div class="body-2 font-weight-bold mr-2">{{ coaNumber(item) }}</div>
                          <div class="caption grey--text">{{ coaName(item) }}</div>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Kode"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Kode
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Contoh: S1"
                      hide-details="auto"
                      v-model="sumberDanaForm.code"
                      :success="valid"
                      :error-messages="errors"
                      required
                      class="mb-3"
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <div v-if="message.sumberDanaError.length > 0"
                    class="text-center mt-2">
                    <div class="error--text d-flex align-start">
                      <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>

                      <span class="ml-1">
                        {{ message.sumberDanaError }}
                      </span>
                    </div>
                  </div>
                </v-form>
              </ValidationObserver>
            </v-card-text>

            <v-divider
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions class="mb-2 px-4">
              <v-spacer/>

              <v-btn
                @click="saveSumberDana()"
                :loading="process.sumberDanaForm"
                :disabled="process.sumberDanaForm"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.sumberDanaForm = false; resetSumberDana();"
                :disabled="process.sumberDanaForm"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOG HAPUS SUMBER DANA -->
        <v-dialog v-model="dialog.sumberDanaDelete"
          @keydown.esc="dialog.sumberDanaDelete = false"
          width="450"
          persistent
          scrollable>
          <v-card class="border-radius">
            <div
              class="d-flex align-center pt-3 pb-0 text-right popup-header px-4 body-1" style="font-weight: 600;">
              Hapus Sumber Dana

              <v-spacer/>

              <v-icon
                @click="dialog.sumberDanaDelete = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>

            <v-divider
              class="mt-3 mb-1"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text class="pt-1 pb-2 px-4">
              Apakah anda yakin akan menghapus akun
              <b>{{ selectedSumberDana.coa_number }} - {{ selectedSumberDana.coa_name }}</b>
              dari Sumber Dana ini?

              <div v-if="message.sumberDanaError.length > 0"
                class="text-center mt-3">
                <div class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>

                  <span class="ml-1">
                    {{ message.sumberDanaError }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions class="mb-2 px-4">
              <v-spacer/>

              <v-btn
                @click="toDeleteSumberDana()"
                :loading="process.sumberDanaDelete"
                :disabled="process.sumberDanaDelete"
                width="120"
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Hapus
              </v-btn>

              <v-btn
                @click="dialog.sumberDanaDelete = false;"
                :disabled="process.sumberDanaDelete"
                width="120"
                outlined
                elevation="0"
                color="grey"
                rounded
                class="body-2 font-weight-bold text-capitalize">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOG TAMBAH -->
        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            
            <div
              class="d-flex align-center pt-3 pb-0 px-4 body-1"
              style="font-weight: 600;">
              Tambah Konfigurasi Laporan Konsolidasi Kas

              <v-spacer/>

              <v-icon
                @click="dialog.form = false; reset();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>

            <v-divider
              class="mt-3 mb-1"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text class="pt-3 pb-2 px-4">
              <ValidationObserver ref="form">
                <v-form>
                  <ValidationProvider
                    name="Kategori"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Kategori Laporan Konsolidasi Kas
                    </div>

                    <v-select
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Pilih Kategori"
                      hide-details="auto"
                      :items="categories"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"
                      v-model="form.category"
                      :success="valid"
                      :error-messages="errors"
                      required
                      class="mb-5"
                      style="border-radius: 10px;">
                    </v-select>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Type"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Type Laporan Konsolidasi Kas
                    </div>

                    <v-select
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Pilih Type"
                      hide-details="auto"
                      :items="types"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"
                      v-model="form.type"
                      :success="valid"
                      :error-messages="errors"
                      required
                      class="mb-5"
                      style="border-radius: 10px;">
                    </v-select>
                  </ValidationProvider>

                  <ValidationProvider
                    name="COA"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>
                      Akun COA
                    </div>

                    <v-autocomplete
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Cari nama / nomor akun COA"
                      hide-details="auto"
                      :items="coaList"
                      :loading="process.coa"
                      :search-input.sync="search_coa"
                      item-text="name_number"
                      item-value="id"
                      :item-color="set_color"
                      v-model="form.coa_id"
                      :success="valid"
                      :error-messages="errors"
                      required
                      class="mb-3"
                      style="border-radius: 10px;">
                      <template v-slot:item="{ item }">
                        <div class="d-flex align-center">
                          <div class="body-2 font-weight-bold mr-2">{{ coaNumber(item) }}</div>
                          <div class="caption grey--text">{{ coaName(item) }}</div>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <div v-if="message.error.length > 0"
                    class="text-center mt-2">
                    <div class="error--text d-flex align-start">
                      <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>

                      <span class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-form>
              </ValidationObserver>
            </v-card-text>

            <v-divider
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions class="mb-2 px-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; dialog.fullscreen = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOG HAPUS -->
        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          width="450"
          persistent
          scrollable>
          <v-card class="border-radius">
            <div
              class="d-flex align-center pt-3 pb-0 text-right popup-header px-4 body-1" style="font-weight: 600;">
              Hapus Konfigurasi Laporan Konsolidasi Kas

              <v-spacer/>

              <v-icon
                @click="dialog.delete = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </div>

            <v-divider
              class="mt-3 mb-1"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text class="pt-1 pb-2 px-4">
              Apakah anda yakin akan menghapus akun
              <b>{{ selected.coa_number }} - {{ selected.coa_name }}</b>
              dari Konfigurasi Laporan Konsolidasi Kas ini?

              <div v-if="message.error.length > 0"
                class="text-center mt-3">
                <div class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>

                  <span class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions class="mb-2 px-4">
              <v-spacer/>

              <v-btn
                @click="toDelete()"
                :loading="process.delete"
                :disabled="process.delete"
                width="120"
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Hapus
              </v-btn>

              <v-btn
                @click="dialog.delete = false;"
                :disabled="process.delete"
                width="120"
                outlined
                elevation="0"
                color="grey"
                rounded
                class="body-2 font-weight-bold text-capitalize">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
        <v-card
          flat
          color="transparent">
          <v-card-text class="pt-1 pb-0">
            <div class="d-flex align-center">
              <div class="d-flex align-center">
                <v-avatar tile size="22">
                  <v-img
                    contain
                    alt="cashflow"
                    :src="require('@/assets/image/grip_menu.png')">
                    <template v-slot:placeholder>
                      <v-row class="fill-height" align="center" justify="center">
                        <v-progress-circular size="20" indeterminate :color="set_color"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span class="fs-16 black--text ml-2" style="font-weight: 600;">
                  Konfigurasi & Sumber Dana Laporan Konsolidasi Kas
                </span>
              </div>

              <v-spacer/>
            </div>

            <div class="mt-3">
              <v-tabs
                v-model="tab"
                dense
                background-color="transparent"
                slider-size="5"
                :color="set_color"
                @change="onTabChange">
                <v-tab>
                  <span class="body-2 font-weight-medium text-capitalize">
                    Konfig Konsolidasi Kas
                  </span>
                </v-tab>
                <v-tab>
                  <span class="body-2 font-weight-medium text-capitalize">
                    Sumber Dana
                  </span>
                </v-tab>
              </v-tabs>
              <v-divider style="border-color: #EBEEF2;"></v-divider>
            </div>
          </v-card-text>
        </v-card>

        <v-row v-if="tab === 0" class="pa-5 pt-2 pb-0">
          <v-col cols="12" class="py-0">
            <div class="d-flex pb-2">
              <v-btn
                color="#4B4B4B"
                elevation="0"
                small
                min-height="30"
                class="fs-12 white--text text-capitalize d-flex align-center"
                style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));"
                @click="dialog.form = true;">
                <v-icon size="15">mdi-plus-circle-multiple</v-icon>
                <span class="ml-2">Tambah</span>
              </v-btn>
            </div>

            <v-card
              flat
              style="border-radius: 10px; border: 1px solid #E7E7E7;">
              <v-card-text class="px-0 py-2">

                <div v-if="process.load">
                  <v-skeleton-loader
                    v-for="n in 6"
                    :key="n"
                    type="list-item-avatar">
                  </v-skeleton-loader>
                </div>

                <div v-else>
                  <div style="max-height: calc(100vh - 260px); overflow-y: auto;">
                    <div v-for="(cat, c) in tree" :key="`cat-${c}`">
                      <div
                        class="cf-tree-row"
                        style="padding-left: 8px; cursor: pointer;"
                        @click="cat.open = !cat.open">
                        <v-icon size="16" style="color: #707070;">
                          {{ isCatOpen(cat) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                        </v-icon>

                        <v-icon size="17" :color="isCatOpen(cat) ? '#e8b339' : '#d9a52a'" class="ml-1">
                          {{ isCatOpen(cat) ? 'mdi-folder-open' : 'mdi-folder' }}
                        </v-icon>

                        <span class="fs-12 ml-1">{{ cat.name }}</span>

                        <span class="fs-11 grey--text ml-2">({{ totalAccounts(cat) }})</span>
                      </div>

                      <template v-if="isCatOpen(cat)">
                        <div v-for="(typ, t) in cat.children" :key="`typ-${c}-${t}`">
                          <div
                            class="cf-tree-row"
                            style="padding-left: 30px; cursor: pointer;"
                            @click="typ.open = !typ.open">
                            <v-icon size="16" style="color: #707070;">
                              {{ isTypOpen(typ) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                            </v-icon>

                            <v-icon size="17" :color="isTypOpen(typ) ? '#e8b339' : '#d9a52a'" class="ml-1">
                              {{ isTypOpen(typ) ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>

                            <span class="fs-12 ml-1">{{ typ.name }}</span>

                            <span class="fs-11 grey--text ml-2">({{ filteredLeafs(typ).length }})</span>
                          </div>

                          <template v-if="isTypOpen(typ)">
                            <div
                              v-if="filteredLeafs(typ).length < 1"
                              :key="`empty-${c}-${t}`"
                              class="fs-11 grey--text font-italic"
                              style="padding-left: 64px; padding-top: 4px; padding-bottom: 4px;">
                              Belum ada akun untuk kategori ini
                            </div>

                            <div
                              v-for="(leaf, l) in filteredLeafs(typ)"
                              :key="`leaf-${c}-${t}-${l}`"
                              class="cf-tree-row cf-leaf-row"
                              style="padding-left: 52px;">

                              <v-icon
                                size="16"
                                class="mr-1"
                                color="red"
                                @click="toDeleteDialog(leaf)">
                                mdi-trash-can-outline
                              </v-icon>

                              <span class="fs-12 ml-1">{{ leaf.coa_number }}</span>
                              <span class="fs-12 ml-1">{{ leaf.coa_name }}</span>
                            </div>
                          </template>
                        </div>
                      </template>
                    </div>
                  </div>

                  <v-card-text
                    v-if="tree.length > 0 && totalAllAccounts() === 0"
                    class="pb-0 my-4"
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img
                        class="mx-auto"
                        contain
                        alt="empty"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Konfigurasi Laporan Konsolidasi Kas
                      </div>
                    </div>
                  </v-card-text>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="tab === 1" class="pa-5 pt-2 pb-0">
          <v-col cols="12" class="py-0">
            <div class="d-flex align-center pb-2">

              <v-btn
                color="#4B4B4B"
                elevation="0"
                small
                min-height="30"
                class="fs-12 white--text text-capitalize d-flex align-center"
                style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));"
                @click="openSumberDanaForm()">
                <v-icon size="15">mdi-plus-circle-multiple</v-icon>
                <span class="ml-2">Tambah</span>
              </v-btn>
              <v-select
                outlined
                rounded
                dense
                hide-details
                :color="set_color"
                :items="positions"
                item-text="name"
                item-value="id"
                :item-color="set_color"
                v-model="sumberDanaFilter.position"
                placeholder="Posisi"
                class="ml-3 sumber-dana-position-filter"
                @change="fetchSumberDana">
              </v-select>
            </div>

            <v-card
              flat
              style="border-radius: 10px; border: 1px solid #E7E7E7;">
              <v-data-table
                :loading="process.sumberDanaLoad"
                loading-text="Sedang memuat data . . ."
                loader-height="5"
                no-data-text="Belum Ada Sumber Dana"
                :headers="sumberDanaHeaders"
                :items="sumberDanaList"
                :items-per-page="-1"
                item-key="id"
                hide-default-footer
                hide-default-header
                class="table-sumber-dana"
                :height="`calc(100vh - 260px)`">
                <template v-slot:header="{ props: { headers } }">
                  <thead>
                    <tr>
                      <th
                        v-for="h in headers"
                        :key="h.value"
                        :style="`min-width: ${h.width || ''}; width: ${h.width || ''}; background-color: ${set_color} !important; color: #fff;`"
                        :class="`text-${h.align}`">
                        <span class="fs-12">{{ h.text }}</span>
                      </th>
                    </tr>
                  </thead>
                </template>

                <template v-slot:item.action="{ item }">
                  <v-icon
                    size="18"
                    color="grey darken-1"
                    class="cursor-pointer mr-2"
                    @click="openEditSumberDanaForm(item)">
                    mdi-pencil-outline
                  </v-icon>

                  <v-icon
                    size="18"
                    color="red"
                    class="cursor-pointer"
                    @click="toDeleteSumberDanaDialog(item)">
                    mdi-trash-can-outline
                  </v-icon>
                </template>

                <template v-slot:item.code="{ item }">
                  <span class="fs-12">{{ item.code }}</span>
                </template>

                <template v-slot:item.coa_number="{ item }">
                  <span class="fs-12">{{ item.coa_number }}</span>
                </template>

                <template v-slot:item.coa_name="{ item }">
                  <span class="fs-12">{{ item.coa_name }}</span>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post } from "@/service/Axios";

  export default {
    data () {
      return {
        tab: 0,

        dialog: {
          fullscreen: false,
          snackbar: false,
          form: false,
          delete: false,
          sumberDanaForm: false,
          sumberDanaDelete: false
        },

        search: '',
        search_coa: '',

        categories: [
          { id: 'operasi', name: 'Aktivitas Operasi' },
          { id: 'investasi', name: 'Aktivitas Investasi' },
          { id: 'pendanaan', name: 'Aktivitas Pendanaan' }
        ],
        types: [
          { id: 0, name: 'Uang Masuk' },
          { id: 1, name: 'Uang Keluar' }
        ],

        tree: [],
        list: [],
        sumberDanaList: [],
        sumberDanaCoaList: [],
        sumberDanaFilter: {
          position: 'internal'
        },
        positions: [
          { id: 'internal', name: 'Internal' },
          { id: 'public', name: 'Public' }
        ],
        sumberDanaHeaders: [
          { text: 'Aksi', value: 'action', align: 'center', width: '100px', sortable: false },
          { text: 'Kode', value: 'code', align: 'start', width: '80px', sortable: false },
          { text: 'Nomor Akun', value: 'coa_number', align: 'start', width: '150px', sortable: false },
          { text: 'Nama Akun', value: 'coa_name', align: 'start', sortable: false, width: '100%' },
        ],

        coaList: [],

        selected: {},
        selectedSumberDana: {},

        form: {
          id: '',
          category: '',
          type: '',
          coa_id: ''
        },

        sumberDanaForm: {
          id: '',
          coa_id: '',
          position: 'internal',
          code: ''
        },

        process: {
          load: false,
          form: false,
          delete: false,
          coa: false,
          sumberDanaLoad: false,
          sumberDanaForm: false,
          sumberDanaDelete: false,
          sumberDanaCoa: false
        },

        message: {
          success: '',
          error: '',
          sumberDanaError: ''
        }
      }
    },
    computed: {
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.08)`
      }
    },
    mounted () {
      this.fetch()
      this.fetchCoa()
    },
    methods: {
      onTabChange () {
        if (this.tab === 0) {
          this.fetch()
        } else if (this.tab === 1) {
          this.fetchSumberDana()
        }
      },

      isCatOpen (cat) {
        return this.search.length > 0 ? true : cat.open
      },

      isTypOpen (typ) {
        return this.search.length > 0 ? true : typ.open
      },

      filteredLeafs (typ) {
        let keyword = (this.search || '').toLowerCase()

        if (keyword.length < 1) return typ.children

        return typ.children.filter(leaf => {
          return (leaf.coa_number || '').toLowerCase().includes(keyword) ||
            (leaf.coa_name || '').toLowerCase().includes(keyword)
        })
      },

      totalAccounts (cat) {
        return cat.children.reduce((sum, typ) => sum + this.filteredLeafs(typ).length, 0)
      },

      totalAllAccounts () {
        return this.tree.reduce((sum, cat) => sum + this.totalAccounts(cat), 0)
      },

      coaNumber (item) {
        return item.coa_number || item.number || ''
      },

      coaName (item) {
        return item.coa_name || item.name || ''
      },

      coaNameNumber (item) {
        let number = this.coaNumber(item),
            name = this.coaName(item)

        return number && name ? `${number} - ${name}` : name || number
      },

      buildTree () {
        this.tree = this.categories.map(cat => {
          return {
            id: cat.id,
            name: cat.name,
            open: true,
            children: this.types.map(typ => {
              return {
                id: typ.id,
                name: typ.name,
                open: false,
                children: this.list.filter(item => {
                  return item.category === cat.id && parseInt(item.type) === typ.id
                })
              }
            })
          }
        })
      },

      // FETCH 6 KALI (3 KATEGORI x 2 TYPE)
      async fetch () {
        this.process.load = true
        this.list = []

        let requests = []

        this.categories.map(cat => {
          this.types.map(typ => {
            requests.push(
              get(`cashflow/config/data`, {
                params: {
                  category: cat.id,
                  type: typ.id
                }
              }).then(response => {
                let res = response.data

                if (res.status === 200) {
                  res.results.data.map(item => {
                    this.list.push(item)
                  })
                }
              })
            )
          })
        })

        await Promise.all(requests)

        this.process.load = false

        this.buildTree()
      },

      async fetchCoa () {
        this.process.coa = true

        await get('jurnal/coa/options', {
          params: { limit: 100000, position: 'internal' }
        }).then(response => {
          let res = response.data

          this.process.coa = false
          this.coaList = []

          if (res.status === 200) {
            res.results.data.map(item => {
              this.coaList.push({
                ...item,
                name_number: this.coaNameNumber(item)
              })
            })
          }
        })
      },

      reset () {
        this.message.error = ''

        this.form = {
          id: '',
          category: '',
          type: '',
          coa_id: ''
        }

        if (this.$refs.form) this.$refs.form.reset()
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let coa = this.coaList.find(item => item.id === this.form.coa_id) || {}

          await post(`cashflow/config/add`, {
            data: {
              category: this.form.category,
              type: this.form.type,
              coa_id: this.form.coa_id,
              coa_number: this.coaNumber(coa),
              coa_name: this.coaName(coa)
            }
          }).then(response => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false
              this.dialog.fullscreen = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.reset()
              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        }
      },

      toDeleteDialog (leaf) {
        this.message.error = ''
        this.selected = leaf

        this.dialog.delete = true
      },

      async toDelete () {
        this.message.error = ''
        this.process.delete = true

        await post(`cashflow/config/delete`, {
          data: { id: this.selected.id }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {
            this.dialog.delete = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.selected = {}
            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

      async fetchSumberDana () {
        this.process.sumberDanaLoad = true
        this.sumberDanaList = []

        await get(`cashflow/sumber_dana/data`, {
          params: { position: this.sumberDanaFilter.position }
        }).then(response => {
          let res = response.data

          this.process.sumberDanaLoad = false

          if (res.status === 200) {
            this.sumberDanaList = res.results.data || []
          }
        })
      },

      async fetchSumberDanaCoa () {
        this.process.sumberDanaCoa = true

        await get('jurnal/coa/options', {
          params: {
            limit: 100000,
            position: this.sumberDanaForm.position
          }
        }).then(response => {
          let res = response.data

          this.process.sumberDanaCoa = false
          this.sumberDanaCoaList = []

          if (res.status === 200) {
            res.results.data.map(item => {
              this.sumberDanaCoaList.push({
                ...item,
                name_number: this.coaNameNumber(item)
              })
            })
          }
        })
      },

      openSumberDanaForm () {
        this.sumberDanaForm.id = ''
        this.sumberDanaForm.position = this.sumberDanaFilter.position
        this.sumberDanaForm.coa_id = ''
        this.sumberDanaForm.code = ''
        this.fetchSumberDanaCoa()
        this.dialog.sumberDanaForm = true
      },

      openEditSumberDanaForm (item) {
        this.message.sumberDanaError = ''

        this.sumberDanaForm.id = item.id
        this.sumberDanaForm.position = item.position
        this.sumberDanaForm.coa_id = item.coa_id
        this.sumberDanaForm.code = item.code
        this.fetchSumberDanaCoa()
        this.dialog.sumberDanaForm = true
      },

      onSumberDanaFormPositionChange () {
        this.sumberDanaForm.coa_id = ''
        this.fetchSumberDanaCoa()
      },

      resetSumberDana () {
        this.message.sumberDanaError = ''

        this.sumberDanaForm = {
          id: '',
          coa_id: '',
          position: this.sumberDanaFilter.position,
          code: ''
        }

        this.sumberDanaCoaList = []

        if (this.$refs.sumberDanaForm) this.$refs.sumberDanaForm.reset()
      },

      async saveSumberDana () {
        this.message.sumberDanaError = ''

        const isValid = await this.$refs.sumberDanaForm.validate()

        if (isValid) {
          this.process.sumberDanaForm = true

          const isEdit = !!this.sumberDanaForm.id

          const payload = {
            coa_id: this.sumberDanaForm.coa_id,
            position: this.sumberDanaForm.position,
            code: this.sumberDanaForm.code
          }

          if (isEdit) payload.id = this.sumberDanaForm.id

          await post(`cashflow/sumber_dana/${isEdit ? 'update' : 'add'}`, {
            data: payload
          }).then(response => {
            let res = response.data

            this.process.sumberDanaForm = false

            if (res.status === 200) {
              this.dialog.sumberDanaForm = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.sumberDanaFilter.position = this.sumberDanaForm.position
              this.resetSumberDana()
              this.fetchSumberDana()
            } else {
              this.message.sumberDanaError = res.message
            }
          })
        }
      },

      toDeleteSumberDanaDialog (item) {
        this.message.sumberDanaError = ''
        this.selectedSumberDana = item

        this.dialog.sumberDanaDelete = true
      },

      async toDeleteSumberDana () {
        this.message.sumberDanaError = ''
        this.process.sumberDanaDelete = true

        await post(`cashflow/sumber_dana/delete`, {
          data: { id: this.selectedSumberDana.id }
        }).then(response => {
          let res = response.data

          this.process.sumberDanaDelete = false

          if (res.status === 200) {
            this.dialog.sumberDanaDelete = false

            this.dialog.snackbar = true
            this.message.success = res.message

            this.selectedSumberDana = {}
            this.fetchSumberDana()
          } else {
            this.message.sumberDanaError = res.message
          }
        })
      }
    }
  }
</script>

<style scoped>
  .cf-tree-row {
    display: flex;
    align-items: center;
    min-height: 26px;
    padding-top: 3px;
    padding-bottom: 3px;
  }
  .cf-tree-row:hover {
    background: #f0f4fa;
  }
  .cf-leaf-delete {
    opacity: 0;
    cursor: pointer;
    transition: opacity 0.15s ease;
  }
  .cf-leaf-row:hover .cf-leaf-delete {
    opacity: 1;
  }
  .table-sumber-dana >>> table > thead > tr > th {
    font-weight: 600 !important;
    font-size: 12px !important;
    height: 40px !important;
  }
  .table-sumber-dana >>> table > tbody > tr > td {
    font-size: 12px !important;
    height: 40px !important;
  }
  .table-sumber-dana >>> table > tbody > tr:hover {
    background: #f0f4fa !important;
  }
  .sumber-dana-position-filter {
    max-width: 150px;
    border-radius: 6px;
  }
  .sumber-dana-position-filter >>> .v-input__control {
    min-height: 30px !important;
  }
  .sumber-dana-position-filter >>> .v-input__slot {
    min-height: 30px !important;
    padding: 0 16px !important;
  }
  .sumber-dana-position-filter >>> .v-select__selections {
    min-height: 30px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .sumber-dana-position-filter >>> .v-input__append-inner {
    margin-top: 2px !important;
  }
</style>